const LOADING_TEXTS = [
  'Coletando os dados da sua empresa',
  'Analisando informações para gerar os planos',
  'Buscando os dados necessários no sistema',
  'Entendendo o contexto da sua empresa',
  'Preparando as recomendações personalizadas',
  'Cruzando informações para sugerir as melhores ações',
]

export default {
  LOADING_TEXTS,
}
